module.exports = __webpack_public_path__ + "files/7dbbceb74394d44a8f0ef8a02cdf22d4.png";